export default function Loading({ display }: { display: string }) {
  return <h1>{display}</h1>;
}
